import {
    get,
    post,
    put
} from "./http";
import qs from 'qs'


//产业园---左上-新材料(炭基导电)企业数量统计
export const leftOneList = (params) => {
    let url = "/jysk/brain/industrial/park/left/one/list";
    return get(url, params);
}

// 产业园---左中-新材料(炭基导电)产业开工率趋势
export const leftTwoList = (params) => {
    let url = "/jysk/brain/industrial/park/left/two/list";
    return get(url, params);
}
// 产业园---左下-炭基导电企业区域统计
export const leftThreeList = (params) => {
    let url = "/jysk/brain/industrial/park/left/Three/list";
    return get(url, params);
}

//产业园---右上-云端产能
export const rightOneList = (params) => {
    let url = "/jysk/brain/industrial/park/right/one";
    return get(url, params);
}

//产业园---右中-云端产值
export const rightTwoList = (params) => {
    let url = "/jysk/brain/industrial/park/right/two";
    return get(url, params);
}

//产业园---右下-区域产能
export const rightThreeList = (params) => {
    let url = "/jysk/brain/industrial/park/right/three";
    return get(url, params);
}

//产业图谱---地图数据
export const mapList = (params) => {
    let url = "/jysk/brain/industrial/park/industry/map";
    return get(url, params);
}

//产业图谱---中间-地图-详情 
export const productType = (params) => {
    let url = "/jysk/brain/industrial/park/center/product/type";
    return get(url, params);
}

//产业图谱---中间-地图-详情 
export const detailMap = (params) => {
    let url = "/jysk/brain/industrial/park/center/detail/map";
    return get(url, params);
}
